import { useFormik } from "formik";
import * as Yup from "yup";
import { TextInput, CustomSelect } from "..";
import { connect, ConnectedProps } from "react-redux";
import {
  addUser,
  updateUser,
  editUserUpdate,
  UserApprove,
  UserReject,
} from "@/store/user/user.action";
import { RootState } from "../../store";
import { useEffect, useState, useRef } from "react";
import UserServices from "./UserServices";
import { toast } from "..";
import UserDetailsFTP from "./UserDetailsFTP";
import { getCurrentUser } from "@/store/user/user.action";
import UserSettings from "./UserSettings";
import SidebarNavigation, {
  SidebarMenuItem,
} from "../SidebarNavigation/SidebarNavigation";
import { User, GlobeLock, FolderLock, LogIn } from "lucide-react";
import { formatEntityName } from "@/utils/utilFunctions/entityName";

// Define the validation schema using Yup
const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Primary Email is required"),
  name: Yup.string()
    .min(3, "Full Name must be at least 3 characters")
    .required("Full Name is required"),
  // phone: Yup.string().required('Mobile Number is required'),
  // login_type: Yup.string().required('Login Type is required'),
  business: Yup.string().required("Business is required"),
  team: Yup.string().required("Team is required"),
  permissions: Yup.array().min(1, "At least one permission is required"),
  user_role: Yup.string().required("User Role is required"),
  status: Yup.number().required("Status is required"),
});

interface AddUserFormProps {
  onClose: () => void;
  registerSubmit?: (submitFn: () => void) => void;
  isEdit?: boolean;
  item?: any;
  isApprove?: boolean;
  isReject?: boolean;
  isView?: boolean;
  setIsAddUserDisabled?: (isDisabled: boolean) => void;
  getListUser?: any;
  setFilters?: any;
}

export const AddUserForm = ({
  addUser,

  onClose,
  currentUser,
  updateUser,
  isEdit = false,
  item,
  editUserUpdate,
  isReject = false,
  isView = false,
  UserApprove,
  setIsAddUserDisabled,
  UserReject,

  bunchProductList,
  bunchBusinessList,
  bunchAllProductList,
  bunchAllBusinessList,

  getListUser,
  setFilters,
}: Props) => {
  const [filteredProductList, setFilteredProductList] = useState<any[]>([]);
  const [ftpStatus, setFtpStatus] = useState<any>(item?.ftp?.status || 0);
  const [ftpPassword, setFtpPassword] = useState<any>(
    item?.ftp?.password || ""
  );
  const [activeSection, setActiveSection] = useState<string>("basic-info");

  const basicInfoRef = useRef<HTMLDivElement>(null);
  const ftpLoginRef = useRef<HTMLDivElement>(null);
  const accessRef = useRef<HTMLDivElement>(null);
  const sessionRef = useRef<HTMLDivElement>(null);

  const [defaultAdded, setDefaultAdded] = useState<boolean>(false);
  const [addedTeam, setAddedTeam] = useState<string>("");
  const [addedBusiness, setAddedBusiness] = useState<string>("");
  // Define sidebar menu items
  const sidebarMenuItems: SidebarMenuItem[] = [
    {
      id: "basic-info",
      label: "Basic Information",
      icon: User,
      sectionRef: basicInfoRef,
    },
    {
      id: "ftp-login",
      label: "FTP Login",
      icon: GlobeLock,
      sectionRef: ftpLoginRef,
    },
    {
      id: "manage-access",
      label: "Manage Access",
      icon: FolderLock,
      sectionRef: accessRef,
    },
  ];
  const sidebarMenuItemsEdit: SidebarMenuItem[] = [
    ...sidebarMenuItems,
    {
      id: "session-list",
      label: "Active Logins",
      icon: LogIn,
      sectionRef: sessionRef,
    },
  ];

  useEffect(() => {
    setFtpStatus(item?.ftp?.status || 0);
    setFtpPassword(item?.ftp?.password || "");
  }, [item]);

  const handleFtpStatusChange = (value: any) => {
    setFtpStatus(value);
  };

  const handleFtpPasswordChange = (value: any) => {
    setFtpPassword(value);
  };

  const formik = useFormik({
    validateOnChange: false,
    validateOnMount: false,
    initialValues: {
      email: item?.email || "",
      secondary_email: item?.emails?.[0] || "",
      emails: item?.emails || [],
      name: item?.name || "",
      phone: item?.phone || "",
      login_type: 2,
      login_security: 1,
      business: item?.business || "",
      team: item?.team || "",
      default_business: item?.business || "",
      default_team: item?.team || "",
      permissions: item?.permissions || [],
      username: item?.username || "",
      status: item?.status || 1,
      statusValue: "r",
      user_role: item?.user_role || "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const replaced = values?.permissions?.map(
        (item: any) =>
          item
            .split(".") // break into segments
            .map((part: any) => {
              const clean = part?.trim().toLowerCase();
              return clean.includes("all") ? "*" : part.trim();
            })
            .join(".") // rejoin
      );
      const userData = {
        ...values,
        permissions: replaced,
        default_business: values.business,
        default_team: values.team,
        team: values.team,
        emails: [values.secondary_email],
        ftp: {
          email: values.email,
          status: ftpStatus,
          password: ftpPassword,
        },
      };
      if (isEdit) {
        await editUserUpdate({ ...userData, id: item.id });
        // await getListUser();
        onClose();
      } else if (isView) {
        await UserApprove({ ...userData, id: item.id });
        // await getListUser();
        onClose();
      } else {
        try {
          await addUser(userData, () => {
            onClose();
          });
          await getListUser();
        } catch (error) {
          // toast.fail('');
        }
      }
      // await getListUser();
      setFilters({});
    },
  });

  // don't need the below logic for now, now sync is not required
  // useEffect(() => {
  //   if (formik.values.business && formik.values.team) {
  //     const defaultPermission = `${formik.values.business}.${formik.values.team}.cms`;

  //     // Check if the default permission already exists in the permissions array
  //     const hasDefaultPermission = formik.values.permissions?.some(
  //       (permission: string) => permission.startsWith(defaultPermission)
  //     );

  //     // Check for conflicting broader permissions
  //     const hasConflictingPermissions = formik.values.permissions?.some(
  //       (permission: string) => {
  //         const permissionParts = permission.split(".");

  //         // Check for business.* pattern (business.*.anyvalue)
  //         if (
  //           permissionParts[0] === formik.values.business &&
  //           permissionParts[1] === "*"
  //         ) {
  //           return true;
  //         }

  //         // Check for *.anyteam pattern (*.anyvalue)
  //         if (permissionParts[0] === "*") {
  //           return true;
  //         }

  //         // Check for business.team.* pattern (business.team.*)
  //         if (
  //           permissionParts[0] === formik.values.business &&
  //           permissionParts[1] === formik.values.team &&
  //           permissionParts[2] === "*"
  //         ) {
  //           return true;
  //         }

  //         return false;
  //       }
  //     );

  //     // Only add if it doesn't already exist and no conflicting permissions
  //     if (
  //       !defaultAdded &&
  //       !hasDefaultPermission &&
  //       !hasConflictingPermissions
  //     ) {
  //       const updatedPermissions = [
  //         ...(formik.values.permissions || []),
  //         `${defaultPermission}.w`,
  //       ];
  //       formik.setFieldValue("permissions", updatedPermissions);
  //       setAddedTeam(formik.values.team);
  //       setAddedBusiness(formik.values.business);
  //       setDefaultAdded(true);
  //     } else if (defaultAdded && !hasConflictingPermissions) {
  //       const updatedPermissions = formik.values.permissions?.filter(
  //         (permission: string) =>
  //           !permission.startsWith(`${addedBusiness}.${addedTeam}.cms`)
  //       );
  //       updatedPermissions.push(`${defaultPermission}.w`);
  //       formik.setFieldValue("permissions", updatedPermissions);
  //       setAddedTeam(formik.values.team);
  //       setAddedBusiness(formik.values.business);
  //       setDefaultAdded(true);
  //     } else if (hasConflictingPermissions && defaultAdded) {
  //       // Remove default permission if conflicting broader permissions exist
  //       const updatedPermissions = formik.values.permissions?.filter(
  //         (permission: string) =>
  //           !permission.startsWith(`${addedBusiness}.${addedTeam}.cms`)
  //       );
  //       formik.setFieldValue("permissions", updatedPermissions);
  //       setAddedTeam("");
  //       setAddedBusiness("");
  //       setDefaultAdded(false);
  //     }
  //   } else {
  //     if (defaultAdded) {
  //       const updatedPermissions = formik.values.permissions?.filter(
  //         (permission: string) =>
  //           !permission.startsWith(`${addedBusiness}.${addedTeam}.cms`)
  //       );
  //       formik.setFieldValue("permissions", updatedPermissions);
  //       setAddedTeam("");
  //       setAddedBusiness("");
  //       setDefaultAdded(false);
  //     }
  //   }
  // }, [formik.values.business, formik.values.team]);

  // don't need the below logic for now, now sync is not required

  // useEffect(() => {
  //   if (formik.values.business && formik.values.team) {
  //     const defaultPermission = `${formik.values.business}.${formik.values.team}.cms`;

  //     // Check if the default permission exists in the permissions array
  //     const hasDefaultPermission = formik.values.permissions?.some(
  //       (permission: string) => permission.startsWith(defaultPermission)
  //     );

  //     // Check for conflicting broader permissions
  //     const hasConflictingPermissions = formik.values.permissions?.some(
  //       (permission: string) => {
  //         const permissionParts = permission.split(".");

  //         // Check for business.* pattern (business.*.anyvalue)
  //         if (
  //           permissionParts[0] === formik.values.business &&
  //           permissionParts[1] === "*"
  //         ) {
  //           return true;
  //         }

  //         // Check for *.anyteam pattern (*.anyvalue)
  //         if (permissionParts[0] === "*") {
  //           return true;
  //         }

  //         // Check for business.team.* pattern (business.team.*)
  //         if (
  //           permissionParts[0] === formik.values.business &&
  //           permissionParts[1] === formik.values.team &&
  //           permissionParts[2] === "*"
  //         ) {
  //           return true;
  //         }

  //         return false;
  //       }
  //     );

  //     // If default permission is not found and no conflicting permissions exist, clear business and team
  //     if (!hasDefaultPermission && !hasConflictingPermissions && defaultAdded) {
  //       formik.setFieldValue("business", "");
  //       formik.setFieldValue("team", "");
  //       setDefaultAdded(false);
  //       setAddedTeam("");
  //       setAddedBusiness("");
  //     }
  //   }
  // }, [formik.values.permissions]);

  const formattedBusinessList = bunchBusinessList?.map((business: any) => ({
    label: formatEntityName(business) || "N/A",
    value: business.id,
  }));

  const formattedProductList = filteredProductList.map((product: any) => ({
    label: formatEntityName(product) || "N/A",
    value: product.id,
  }));

  const handleCreateUser = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }

    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      formik.setTouched(
        Object.keys(formik.values).reduce(
          (acc, key) => ({ ...acc, [key]: true }),
          {}
        )
      );
      return;
    }

    Object.keys(formik.initialValues).forEach((field) => {
      formik.setFieldTouched(field as keyof typeof formik.initialValues, true);
    });

    formik.submitForm();
  };

  const handleApproveUser = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      formik.setTouched(
        Object.keys(formik.values).reduce(
          (acc, key) => ({ ...acc, [key]: true }),
          {}
        )
      );
      return;
    }

    Object.keys(formik.initialValues).forEach((field) => {
      formik.setFieldTouched(field as keyof typeof formik.initialValues, true);
    });

    formik.submitForm();
  };

  const handleRejectUser = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }

    await UserReject({ id: item.id });
    await getListUser();

    onClose();
  };

  useEffect(() => {
    if (formik.values.email) {
      const username = formik.values.email.split("@")[0];
      formik.setFieldValue("username", username);
    }
  }, [formik.values.email]);

  const deepEqualIgnoreExtraKeys = (a: any, b: any): boolean => {
    // If both are arrays → compare item by item
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      return a.every((item, index) => deepEqualIgnoreExtraKeys(item, b[index]));
    }

    // If both are objects → compare only keys present in `a`
    if (typeof a === "object" && typeof b === "object" && a && b) {
      return Object.keys(a).every((key) =>
        deepEqualIgnoreExtraKeys(a[key], b[key])
      );
    }

    // Fallback: direct comparison
    return a === b;
  };
  useEffect(() => {
    const initialValues = formik.initialValues;
    const currentValues = formik.values;

    // Create initial FTP object for comparison
    const initialFtp = {
      status: item?.ftp?.status || 0,
      password: item?.ftp?.password || "",
    };

    // Create current FTP object for comparison
    const currentFtp = {
      status: ftpStatus,
      password: ftpPassword,
    };

    // Check if basic form fields have changed
    const basicFieldsHaveChanges = !deepEqualIgnoreExtraKeys(
      initialValues,
      currentValues
    );

    // Check if FTP settings have changed
    const ftpHasChanges = !deepEqualIgnoreExtraKeys(initialFtp, currentFtp);

    // Check if permissions have changed
    const permissionsHaveChanges = !deepEqualIgnoreExtraKeys(
      item?.permissions || [],
      currentValues.permissions || []
    );

    // Enable button if any of the fields have changed from initial state
    const shouldEnableButton =
      basicFieldsHaveChanges || ftpHasChanges || permissionsHaveChanges;
    setIsAddUserDisabled?.(!shouldEnableButton);
  }, [
    formik.values,
    formik.initialValues,
    ftpStatus,
    ftpPassword,
    item?.ftp?.status,
    item?.ftp?.password,
    item?.permissions,
    setIsAddUserDisabled,
  ]);

  useEffect(() => {
    if (bunchProductList?.length === 0) return;
    if (formik.values.business) {
      const filteredProducts = bunchProductList.filter(
        (product: any) => product.business === formik.values.business
      );
      setFilteredProductList(filteredProducts);

      // Check if current team belongs to the selected business
      const isTeamValid = filteredProducts.some(
        (product: any) => product.id === formik.values.team
      );

      // If team is not valid for the new business, reset it
      if (!isTeamValid && formik.values.team) {
        formik.setFieldValue("team", "");
      }
    } else {
      setFilteredProductList([]);
      formik.setFieldValue("team", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.business, formik.values.team, bunchProductList]);

  const handleUpdateUser = () => {
    handleCreateUser();
  };

  useEffect(() => {
    const handleUserCreate = () => {
      handleCreateUser();
    };

    window.addEventListener("createUser", handleUserCreate);
    return () => {
      window.removeEventListener("createUser", handleUserCreate);
    };
  }, []);

  useEffect(() => {
    const handleUserUpdate = () => {
      handleUpdateUser();
    };

    window.addEventListener("updateUser", handleUserUpdate);
    return () => {
      window.removeEventListener("updateUser", handleUserUpdate);
    };
  }, []);

  useEffect(() => {
    const handleUserApprove = () => {
      handleApproveUser();
    };

    window.addEventListener("approveUser", handleUserApprove);
    return () => {
      window.removeEventListener("approveUser", handleUserApprove);
    };
  }, []);

  useEffect(() => {
    const handleUserReject = () => {
      handleRejectUser();
    };

    window.addEventListener("rejectUser", handleUserReject);
    return () => {
      window.removeEventListener("rejectUser", handleUserReject);
    };
  }, []);

  return (
    <div className="mx-2 my-3 row">
      <SidebarNavigation
        menuItems={isEdit ? sidebarMenuItemsEdit : sidebarMenuItems}
        activeItem={activeSection}
        onItemClick={setActiveSection}
        className="sticky-top col-sm-5 col-md-4 col-lg-3 sticky-top sidebar-top"
      />
      <form
        className="col-sm-7 col-md-8 col-lg-9 gap-3"
        onSubmit={formik.handleSubmit}
      >
        <div ref={basicInfoRef} className="card mx-0 mb-4 pb-3">
          <div className="card-header py-3 bg-light border-0">
            <h6 className="text-uppercase">Basic Information</h6>
          </div>
          <div className="row p-2 gy-2 m-0">
            <div className="col-6">
              <TextInput
                className="my-1 mb-1"
                name="email"
                label="Primary Email ID"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                showRequired={true}
                error={formik.errors.email as string}
                touched={formik.touched.email as boolean}
                disabled={isEdit || isView}
              />
            </div>
            <div className="col-6">
              <TextInput
                className="my-1 mb-1"
                name="secondary_email"
                label="Secondary Email ID"
                value={formik.values.secondary_email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                showRequired={false}
                error={
                  formik.touched.secondary_email &&
                  formik.errors.secondary_email
                    ? (formik.errors.secondary_email as string)
                    : ""
                }
                touched={formik.touched.secondary_email as boolean}
              />
            </div>
            <div className="col-6">
              <TextInput
                name="name"
                label="Full Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                showRequired={true}
                error={formik.errors.name as string}
                touched={formik.touched.name as boolean}
                rightElement={
                  <span className="text-muted small">(min: 3)</span>
                }
              />
            </div>
            <div className="col-6">
              <TextInput
                name="phone"
                label="Mobile Number"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                showRequired={false}
                error={formik.errors.phone as string}
                touched={formik.touched.phone as boolean}
              />
            </div>
            <div className="col-6">
              <CustomSelect
                name="business"
                label="Business"
                value={formik.values.business}
                showRequired={true}
                options={formattedBusinessList}
                handleChange={(newValue: any) => {
                  formik.setFieldValue("business", newValue.value);
                  formik.setFieldValue("team", "");
                  formik.setFieldError("business", undefined);
                }}
                handleBlur={() => formik.setFieldTouched("business", true)}
                // disabled={isEdit || isView} //commented for development purpose to be uncommented later
                updatedOptions={formattedBusinessList}
                error={formik.errors.business as string}
                touched={formik.touched.business as boolean}
              />
            </div>
            <div className="col-6">
              <CustomSelect
                name="team"
                disabled={!formik.values.business}
                label="Team/Property"
                value={formik.values.team}
                showRequired={true}
                options={formattedProductList}
                handleChange={(newValue: any) => {
                  formik.setFieldValue("team", newValue.value);
                  formik.setFieldError("team", undefined);
                }}
                handleBlur={() => formik.setFieldTouched("team", true)}
                updatedOptions={formattedProductList}
                error={formik.errors.team as string}
                touched={formik.touched.team as boolean}
              />
            </div>
            <div className="col-6">
              <CustomSelect
                name="user_role"
                label="User Role"
                value={formik.values.user_role}
                showRequired={true}
                options={[
                  { label: "Business", value: "business" },
                  { label: "Product", value: "product" },
                  { label: "Editor", value: "editor" },
                ]}
                handleChange={(newValue: any) => {
                  formik.setFieldValue("user_role", newValue.value);
                  formik.setFieldError("user_role", undefined);
                }}
                handleBlur={() => formik.setFieldTouched("user_role", true)}
                error={formik.errors.user_role as string}
                touched={formik.touched.user_role as boolean}
              />
            </div>
            <div className="col-6">
              <CustomSelect
                name="status"
                label="Status"
                value={formik.values.status}
                showRequired={true}
                options={[
                  { label: "Active", value: 1 },
                  { label: "Inactive", value: 2 },
                ]}
                handleChange={(newValue: any) => {
                  formik.setFieldValue("status", newValue.value);
                  formik.setFieldError("status", undefined);
                }}
                handleBlur={() => formik.setFieldTouched("status", true)}
                menuWidth="90%"
                error={formik.errors.status as string}
                touched={formik.touched.status as boolean}
              />
            </div>
          </div>
        </div>

        <div ref={ftpLoginRef} className="card mx-0 mb-4 pb-3">
          <div className="card-header py-3 bg-light border-0">
            <h6 className="text-uppercase">FTP Login</h6>
          </div>
          <div className="row p-2 py-2 m-0">
            <UserDetailsFTP
              status={ftpStatus}
              email={formik.values.email}
              pass={ftpPassword}
              updateUser={updateUser}
              currentUser={currentUser}
              showUpdate={false}
              handleStatusChange={handleFtpStatusChange}
              handlePasswordChange={handleFtpPasswordChange}
            />
          </div>
        </div>

        <div className="row py-3 m-0">
          <div className="card pb-4" ref={accessRef}>
            <UserServices
              value={formik.values.permissions}
              onChange={(perms) => formik.setFieldValue("permissions", perms)}
              productList={bunchAllProductList}
              businessList={bunchAllBusinessList}
              // allProductList={bunchAllProductList}
              // allBusinessList={bunchAllBusinessList}
              isReject={isReject}
              showHeader={true}
              showRequired={true}
              touched={formik.touched.permissions as boolean}
              error={formik.errors.permissions as string}
            />
          </div>
        </div>

        {isEdit && (
          <div className="row py-3 m-0" ref={sessionRef}>
            <UserSettings currentUser={item} />
          </div>
        )}
      </form>
    </div>
  );
};

const mapState = (state: RootState) => ({
  bunchProductList: state.constants.bunchProductList.list,
  bunchBusinessList: state.constants.bunchBusinessList.list,
  bunchAllProductList: state.constants.bunchAllProductList.list,
  bunchAllBusinessList: state.constants.bunchAllBusinessList.list,
  currentUser: state.users.currentUser,
});
const mapDispatch = {
  addUser,
  updateUser,
  getCurrentUser,
  editUserUpdate,
  UserApprove,
  UserReject,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & AddUserFormProps;

export default connector(AddUserForm);
